<template>
  <div class="activity-content">
    <div class="status-timeline">
      <ul v-if="!loading && order">
        <li v-for="(orderStatus, index) in orderStatuses" :key="index">
          <div class="status-wrapper">
            <div>
              <p class="small time">
                {{ formatTime(orderStatus.date).time }}
              </p>
              <p class="small date">
                {{ formatTime(orderStatus.date).date }}
              </p>
            </div>
            <div>
              <div
                :class="[
                  'status-icon',
                  getStatusIconBackground(orderStatus, index)
                ]"
              >
                <pn-icon
                  :symbol="
                    index === 0 ? statuses[orderStatus.status].symbol : 'clock'
                  "
                  :color="statuses[orderStatus.status].color"
                  size="medium"
                  solid
                >
                </pn-icon>
              </div>
            </div>
            <div>
              <p class="small status-text">
                {{ $t(statuses[orderStatus.status].text) }}
              </p>
            </div>
          </div>
        </li>
      </ul>
      <div class="loading" v-if="loading">
        <pn-spinner color="blue" size="medium"></pn-spinner>
      </div>
    </div>
    <img :src="require(`@/assets/images/order-activity-mailbox.svg`)" />
  </div>
</template>

<script>
import moment from 'moment'
import orderDetails from '@/components/order-details-modal/orderDetails.json'

export default {
  name: 'OrderActivityComponent',
  props: {
    order: {
      type: Object
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      statuses: orderDetails.statuses
    }
  },
  computed: {
    orderStatuses() {
      return this.order ? this.order.statuses : []
    }
  },
  methods: {
    formatTime(timestamp) {
      return {
        date: moment(timestamp).format('D MMM'),
        time: moment(timestamp).format('HH:mm')
      }
    },
    getStatusIconBackground(orderStatus, index) {
      return index === 0
        ? this.statuses[orderStatus.status].background
        : 'gray200'
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .loading {
    text-align: center;
  }

  .status-timeline {
    flex: 1;

    ul {
      padding-left: 0;

      li {
        list-style-type: none;
        position: relative;
        padding-bottom: 4.6875em;

        &::after {
          content: '';
          background-color: $gray200;
          position: absolute;
          bottom: 0px;
          top: 0px;
          left: 85px;
          width: 1px;
        }

        &:last-child::after {
          display: none;
        }

        div.status-wrapper {
          display: flex;
          flex-direction: row;
          height: 2.5em;

          > div {
            padding: 0 0.5em;
            display: flex;
            flex-direction: column;
            justify-content: center;
            z-index: 2;
          }

          .time {
            color: $gray900;
          }

          .date {
            color: $gray700;
          }

          .status-text {
            color: $gray900 !important;
            font-weight: 500;
          }

          .status-icon {
            height: 2.5em;
            width: 2.5em;
            border-radius: 1.2em;
            padding: 0.5em;
          }

          .warning {
            background-color: $warning;
          }

          .green700 {
            background-color: $green700;
          }

          .blue700 {
            background-color: $blue700;
          }

          .gray700 {
            background-color: $gray700;
          }

          .coral50 {
            background-color: $coral50;
          }

          .green50 {
            background-color: $green50;
          }

          .gray50 {
            background-color: $gray50;
          }

          .blue50 {
            background-color: $blue50;
          }

          .gray200 {
            background-color: $gray200;
          }
        }
      }
    }
  }

  img {
    width: 100%;
    margin: 0 auto;
    max-width: 15.13em;
    max-height: 10em;
  }
}
</style>
